<p-toast></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>

<div class="field">
  <label for="VariableSelectorDd" class="do-not-wrap-text" *ngIf="doShowLabel">{{labelKey}}</label>
  <div class="p-inputgroup">
    <p-button icon="pi pi-pencil" styleClass="p-button-warning mr-1" (click)="onEditButton($event)" [disabled]="!isThereSelection"
            pTooltip="Редактировать переменную" tooltipPosition="top" *ngIf="doShowEditButton"></p-button>
    <p-dropdown id="VariableSelectorDd"
                [options]="variablesList"
                optionLabel="VARCODESTR"
                [(ngModel)]="_selectedVariable"
                name="_variableMC"
                [placeholder]="placeholder"
                filterPlaceholder="Поиск..."
                [filter]="true"
                [showClear]="true"
                [required]="false"
                [disabled]="_disabled"
                [readonly]="readonly"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"
                (onClick)="onClickVariable($event)"
                (onChange)="onChangeVariable($event)"
                class="p-dropdown-filter">
    </p-dropdown>
    <p-button icon="pi pi-trash" styleClass="p-button-success ml-1" (click)="onDeleteButton($event)" [disabled]="!isThereSelection"
            pTooltip="Удалить переменную" tooltipPosition="top" *ngIf="doShowDeleteButton"></p-button>
    <p-button icon="pi pi-plus" styleClass="p-button-success ml-1" (click)="onAddButton($event)"
            pTooltip="Добавить новую переменную" tooltipPosition="top" *ngIf="doShowAddButton"></p-button>
  </div>
</div>

<p-dialog header="{{_dialogMode === 'add' ? 'Додати змінну' : 'Редагувати змінну'}}"
          [(visible)]="_dialogVisible" [modal]="true" [style]="{width: '28rem'}"
          [closable]="!_saving" [closeOnEscape]="!_saving" appendTo="body">
  <div class="field" *ngIf="_dialogModel">
    <label for="varCode">Код</label>
    <input id="varCode" type="text" pInputText style="width:100%" [(ngModel)]="_dialogModel.VARCODE" [disabled]="_saving">
  </div>
  <div class="field" *ngIf="_dialogModel">
    <label for="varValue">Значення</label>
    <input id="varValue" type="text" pInputText style="width:100%" [(ngModel)]="_dialogModel.VARVALUE" [disabled]="_saving">
  </div>
  <div class="field" *ngIf="_dialogModel">
    <label for="varNote">Примітка</label>
    <input id="varNote" type="text" pInputText style="width:100%" [(ngModel)]="_dialogModel.VARNOTE" [disabled]="_saving">
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Скасувати" styleClass="p-button-text" (onClick)="onDialogCancel()" [disabled]="_saving"></p-button>
    <p-button label="Зберегти" icon="pi pi-check" (onClick)="onDialogSave()" [disabled]="_saving || !_dialogModel?.VARCODE"></p-button>
  </ng-template>
</p-dialog>
